import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService, MessageBrokerService} from './core/index';
import { NotificationsService } from './helper-components/index';

import { ClearanceItemAssetManagerComponent } from '../clearance-item/asset-management/clearance-item-asset-manager.component';
import { ClearanceItemAssetBaseComponent } from '../clearance-item/asset-management/clearance-item-asset-base.component';
import { ClearanceItemImageComponent } from '../clearance-item/asset-management/clearance-item-image.component';
import { ClearanceItemDocumentComponent } from '../clearance-item/asset-management/clearance-item-document.component';
import { SharedModule } from "./shared.module";
import { CommonModule } from '@angular/common';
import { AssetDirective } from "../clearance-item/asset-management/clearance-item-asset-directive";
import { ClickOutsideDirective } from './clickoutside.directive';
import { ClearanceItemService } from '../clearance-item';
import { CarouselComponent } from '../clearance-item/carousel.component';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatProgressBarModule
  ],
  declarations: [
    ClearanceItemAssetManagerComponent,
    ClearanceItemAssetBaseComponent,
    ClearanceItemImageComponent,
    ClearanceItemDocumentComponent,
    AssetDirective,
    // ModalComponent,
    ClickOutsideDirective
  ],
  exports:[
    ClearanceItemAssetManagerComponent,    
    ClearanceItemAssetBaseComponent,
    ClearanceItemImageComponent,
    ClearanceItemDocumentComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
})
export class AssetManagerModule {

  static forRoot(): ModuleWithProviders<AssetManagerModule> {
    return {
      ngModule: AssetManagerModule,
      providers: [AuthService, MessageBrokerService, NotificationsService, ClearanceItemService]
    };
  }
}
